module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Playlist1-03f2ff563f2a3e94d222eda3ef0d8e85.svg";